import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios'
import Config from './config'
import { getTitleForPath } from './routeTitles'

const config = new Config();

export async function GetAllEsignatures() {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    return await  axios({
        method: 'post',
        url: `${config.BASEURL}/getESignature`,
        headers: {
            'Content-type': 'application/x-www-form-urlencoded',
            Authorization: userDetails.token
        },
        data: `user_id=${userDetails.user_id}&company_id=${userDetails.company_id}`
        })
    .then(async response => {
        await response
        if (response.data.status === 1) {
            return response.data.esignatures

        }
        else
        {
            return response.data.esignatures
        }
    })
    .catch(error => console.error('Error:', error))
}

/**
 * Set the title of the window/tab, prefixed with the env designator on
 * non-prod environments. Called by DocumentTitleManager (below) on every
 * route change; not intended to be invoked directly from page components.
 */
export function setTitle(title) {
  // Don't set the window/tab title unless it is a non-empty string.
  if (typeof title !== "string" || !title || title.trim().length === 0) return;

  // Always prefix the title with the ENV !== 'prod'
  switch (config.ENV) {
    case "local":
      document.title = `[LOCAL] ${title}`;
      break;
    case "qa":
      document.title = `[QA] ${title}`;
      break;
    case "staging":
      document.title = `[STG] ${title}`;
      break;
    default:
      // PROD - do nothing
      document.title = title;
      break;
  }
}

/**
 * Mounts at the app root and keeps document.title in sync with the current
 * route via the routeTitles lookup. Drops in a single React component so the
 * title is set on initial mount (covers full-page refresh) and on every
 * client-side navigation.
 *
 * Centralising here prevents the previous failure mode where individual page
 * components forgot to call setTitle — refreshing on one of those pages left
 * the env designator off and the title stuck at whatever the previous page
 * had set (or the static "Bluetail Admin" from index.html).
 */
export function DocumentTitleManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    setTitle(getTitleForPath(pathname));
  }, [pathname]);
  return null;
}